import { ResponseError } from "@/api/openapi";
import notify from "devextreme/ui/notify";
import { notifyDurationLong, notifyPosition } from "@/constants";
import { toast } from "@/hooks/use-toast";
import {
    ApiMultipleResultError,
    ApiResultError,
} from "@/api/mutator/custom-fetch";

// Function to handle errors and show notifications
export async function handleAndNotifyError(
    e: unknown,
    title?: string,
    isNewDesign = true,
    severity: "danger" | "warning" = "danger",
): Promise<string> {
    console.error(e);
    const errorStr = await onExceptionGetMessage(e);
    const isInfoOnly =
        e instanceof ApiResultError && e.errorNo && e.errorNo > 9000;

    if (isNewDesign) {
        toast({
            // Use error string if no title supplied, otherwise use the title and
            // demote the error string to the description
            title: title ?? errorStr,
            description: title ? errorStr : undefined,
            appearance: isInfoOnly ? "information" : severity,
            isBold: true,
        });
    } else {
        notify(
            { message: errorStr, position: notifyPosition },
            "error",
            notifyDurationLong,
        );
    }
    return errorStr;
}

export async function onExceptionGetMessage(e: unknown) {
    let errorStr = "Error occurred while performing this action";

    if (typeof e === "string") {
        errorStr = e;
    } else if (e instanceof ApiResultError && e.result.message) {
        errorStr = e.result.message;
    } else if (e instanceof ApiMultipleResultError && e.result.message) {
        errorStr = e.result.message;
    } else if (e instanceof ResponseError) {
        try {
            const errorResponse = await e.response.json();
            if (typeof errorResponse === "string") {
                errorStr = errorResponse;
            } else {
                console.log("unknown body: ", errorResponse);
                errorStr = `HTTP ${e.response.status}: ${errorResponse.message}`;
            }
        } catch {
            // Do nothing
        }
    }

    return errorStr;
}
